 export default class Index {

    private el: HTMLElement;

    constructor() {
        this.el = document.createElement('div');

        if (window.userData?.isLogin) {
            this.setting();
        }
    }
    
    private setting(){
        let msg = this.checkMsg()
        if ( !msg ) return;
        this.template( msg );
        document.body.appendChild( this.el );
        this.addEvents();
    }

    private checkMsg(): string {
        let msg = '';
        window.userData.accountState?.map( it =>{
            if(it.case==7 || it.case==8) msg = it.msg;
        });
        return msg;
    }

    private template(_msg: string): void {
        this.el.id = "id-verify";
        this.el.classList.add("id-verify");
        this.el.innerHTML = `
        <div class="id-verify__wrapper" data-testid="id-verify">
            ${_msg}<button class="id-verify__close"><span class="blind">X</span></button>
        </div>`;
    }

    private addEvents(){
        document.querySelector<HTMLElement>(".id-verify__close")?.addEventListener('click', () => {
            this.el.parentNode?.removeChild(this.el);
        });
    }

} // end of class